import { JSX, useContext } from "react";
import { Button, Col, Container, Row } from "reactstrap";
//import VCard from 'vcard-creator'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard, faCertificate, faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

//import { toFilename } from "@helpers/card-formatter";
import { BusinesCardInDB, SupportedSocials, UserContextType } from "@types";
import { ICardSocialMedia, NavbarDefault } from "components";
import { UserContext } from "context";

import 'scss/css/style.css';
import 'styles/cardPage.css';
//import { useHref } from "react-router-dom";;

const ambienta = require("/Users/josuearredondo/Pictures/home-page/src/assets/logos/datalegal/ambienta.png");
const ambio = require("/Users/josuearredondo/Pictures/home-page/src/assets/logos/datalegal/ambio.png");
const data = require("/Users/josuearredondo/Pictures/home-page/src/assets/logos/datalegal/data.png");
const datatraning = require("/Users/josuearredondo/Pictures/home-page/src/assets/logos/datalegal/datatraning.png");
const eddata = require("/Users/josuearredondo/Pictures/home-page/src/assets/logos/datalegal/eddata.png");
const bma = require("/Users/josuearredondo/Pictures/home-page/src/assets/logos/datalegal/bma.jpeg");

type CardPageProps = {
    businessCard: BusinesCardInDB;
}

const CardPage = ({ businessCard }: CardPageProps): JSX.Element => {
    const { darkMode } = useContext(UserContext) as UserContextType;

    const downloadVCard = async () => {
        const fullName = businessCard.name.trim();
        const nameParts = fullName.split(" ");
        const lastName = nameParts.pop();
        const firstName = nameParts.join(" ");
        const email = businessCard.email || "";
        const rawPhone = businessCard.socials.whatsapp?.replace(/[^\d]/g, '');
        const phoneNumber = rawPhone ? `+${rawPhone.slice(-12)}` : "";
    
        let photoBase64 = "";
    
        // Convertir imagen remota a base64
        if (businessCard.photo) {
            try {
                const response = await fetch(businessCard.photo);
                const blob = await response.blob();
                const reader = new FileReader();
    
                const base64 = await new Promise<string>((resolve, reject) => {
                    reader.onloadend = () => resolve(reader.result?.toString().split(',')[1] || "");
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                });
    
                photoBase64 = base64;
            } catch (error) {
                console.error("Error al convertir la imagen:", error);
            }
        }
    
        const vCard =
            "BEGIN:VCARD\n" +
            "VERSION:3.0\n" +
            `N:${lastName};${firstName};;;\n` +
            `FN:${fullName}\n` +
            (email ? `EMAIL;TYPE=INTERNET:${email}\n` : "") +
            (phoneNumber ? `TEL;TYPE=CELL:${phoneNumber}\n` : "") +
            (photoBase64 ? `PHOTO;ENCODING=b;TYPE=JPEG:${photoBase64}\n` : "") +
            "END:VCARD";
    
        const blob = new Blob([vCard], { type: "text/vcard;charset=utf-8" });
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = `${fullName.replace(/\s/g, "_")}.vcf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(downloadUrl);
    };
    

    return (
        <Container id='card-page'
            className={`
                pt-4 g-0
                ${darkMode ? 'bg-dark-dark' : ''}
                overflow-hidden
            `}
            fluid
        >
            <NavbarDefault />
            <Container
                id='card-page-content'
                className='overflow-hidden under-navbar'
            >
                <Row
                    id='row-top'
                    className={`
                        ${darkMode ? 'text-light' : ''}
                        justify-content-evenly align-items-center
                        mx-auto mb-3
                    `}
                >
                    <Col xs={6}
                        id='col-info'
                    >
                        <span
                            className='fs-1 fw-bold'
                        >
                            {businessCard.name}
                        </span>
                        <div className='fs-4'>
                            {businessCard.companyName}
                            <br />
                            {businessCard.position}
                            <br />
                            {businessCard.description}
                        </div>
                        {businessCard.website ? "🌐 ": ""}
                        <a className='fs-4' href={businessCard.website}>
                                {businessCard.website ? businessCard.website : ""}
                        </a>
                    </Col>
                    <Col xs={6}
                        id='col-photo'
                        className='text-end'
                    >
                        <img
                            id='photo'
                            src={businessCard.photo}
                            width={300}
                            height={300}
                            className={`
                                ${darkMode ? 'border-light' : 'border-dark'}
                                border border-1
                                rounded-circle
                                user-select-none
                            `}
                            alt={`${businessCard.name}`}
                            draggable={false}
                        />
                    </Col>
                </Row>

                <div className="d-flex justify-content-center align-items-center">
                    {businessCard.companyName === "Data Legal Abogados S.C." && (
                        <Row id="row-images" className="align-items-center justify-content-center text-center w-100">
                            {[data, ambio, ambienta, datatraning, eddata].map((imgSrc, index) => (
                                <Col key={index} xs={4} sm={4} md={3} lg={4} className="d-flex justify-content-center">
                                    <img
                                        src={imgSrc}
                                        style={{ paddingTop: "0px", paddingBottom: "24px" }}
                                        className="w-100 h-32 object-cover user-select-none"
                                        alt={`Imagen ${index + 1}`}
                                        draggable={false}
                                    />
                                </Col>
                            ))}
                        </Row>
                    )}
                </div>

                
                <a href={`mailto:${businessCard.email}`}
                    className={`
                        ${darkMode ? 'text-dark' : 'text-light'}
                        text-decoration-none
                    `}
                >
                    <div className='text-center mb-3'>
                        <Button
                            id='contact-button'
                            className='w-100 contact-button'
                            color={`${darkMode ? 'primary-dark' : 'primary'}`}
                        >
                            <FontAwesomeIcon
                                icon={faEnvelope}
                                className='me-2'
                            />
                            Contactar
                        </Button>
                    </div>
                </a>
                {/* vCar Download */}
                <div className='text-center mb-3'>
                    <Button
                        id='vcard-button'
                        className='w-100 contact-button'
                        color={`${darkMode ? 'primary-dark' : 'primary'}`}
                        onClick={downloadVCard}
                    >
                        <FontAwesomeIcon
                            icon={faAddressCard}
                            className='me-2'
                        />
                        Descargar contacto
                    </Button>
                </div>
                <div className='text-center mb-3'>
                    <a href={`tel: +${businessCard.socials.whatsapp?.slice(businessCard.socials.whatsapp.length -12, businessCard.socials.whatsapp.length)}`}>
                        <Button
                            id='call-button'
                            className='w-100 contact-button'
                            color={`${darkMode ? 'primary-dark' : 'primary'}`}
                            //onClick={useHref}
                        >
                            <FontAwesomeIcon
                                icon={faPhone}
                                className='me-2'
                            />
                            Llamar                    
                        </Button>
                    </a>

                </div>

                <div id='socials-container'
                    className='d-flex flex-wrap justify-content-center'
                >
                    {
                        Object.keys(businessCard.socials).map((social, index) => {
                            const socialName = social as SupportedSocials;
                            const socialUrl = businessCard.socials[socialName];

                            if (!socialUrl) return null;

                            return (
                                <ICardSocialMedia
                                    url={socialUrl}
                                    social={socialName}
                                    key={index}
                                />
                            )
                        })
                    }
                </div>

                <a href={`mailto:${businessCard.email}`}
                    className={`
                        ${darkMode ? 'text-light' : 'text-dark'}
                        text-decoration-none
                    `}
                >
                    <div className='text-center mb-3'>
                        {businessCard.name === "LUIS GONZÁLEZ LOZANO" && (
                                <div 
                                    className='fs-4 justify-content-evenly align-items-center ' 
                                    id="row-top">
                                    Espacios Sociales Personales:
                                    <br />
                                </div>
                            )}
                    </div>
                </a>

                        
                <Row
                    id='row-top'
                    className={`
                        ${darkMode ? 'text-light' : ''}
                        justify-content-evenly align-items-center
                        mx-auto mb-3
                    `}
                >
                    <div id='socials-container'
                        className='d-flex flex-wrap'
                    >
                        {businessCard.name === "LUIS GONZÁLEZ LOZANO" && (
                            <ICardSocialMedia
                            url={"https://x.com/luisglozano"}
                            social={"twitter"}
                            key={4}
                            />
                        )}
                        {businessCard.name === "LUIS GONZÁLEZ LOZANO" && (
                            <ICardSocialMedia
                            url={"https://www.facebook.com/Lozano.LuisG/"}
                            social={"facebook"}
                            key={4}
                            />
                        )}
                        {businessCard.name === "LUIS GONZÁLEZ LOZANO" && (
                            <ICardSocialMedia
                            url={"https://www.linkedin.com/in/luis-gonzalez-lozano-87271237/"}
                            social={"linkedin"}
                            key={4}
                            />
                        )}
                    </div>
                </Row>


                <div className='text-center mb-3'>
                    {businessCard.companyName === "Data Legal Abogados S.C."  && (
                        <>
                            <div className="mb-2 ratio ratio-16x9">
                                <iframe 
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3695.7481934290854!2d-101.04511522444173!3d22.135574479805324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842a99320271207b%3A0x2fea51f3de5f593d!2sData%20Legal%20Abogados%2C%20S.C.!5e0!3m2!1ses-419!2smx!4v1747260598760!5m2!1ses-419!2smx"
                                    width="600" 
                                    height="450" 
                                    style={{border:0}}
                                    allowFullScreen
                                    loading="lazy"
                                    className="rounded"
                                ></iframe>
                            </div>
                            <Button
                                id='contact-button'
                                className='w-100 contact-button'
                                color={`${darkMode ? 'primary-dark' : 'primary'}`}
                                onClick={() => window.open('https://maps.app.goo.gl/hTSbqgD4o2sHY4JT8', '_blank')}
                            >
                                <div className="d-flex align-items-center justify-content-center">
                                    <i className="bi bi-arrow-up-right-circle me-2"></i>
                                    Abrir en Google Maps
                                </div>
                            </Button>
                        </>
                    )}
                </div>

                <a
                    href="https://www.bma.org.mx/barristas-certificados-2023/"
                    className={`
                        ${darkMode ? 'text-dark' : 'text-light'}
                        text-decoration-none
                    `}
                    target="_blank"
                    rel="noopener noreferrer"
                >   
                    <div className="text-center mb-3">
                        {businessCard.name === "LUIS GONZÁLEZ LOZANO" && (
                            <img
                                id="contact-button"
                                src={bma}
                                alt="BMA Abogado certificado"
                                className="w-100 contact-button"
                                style={{ cursor: 'pointer' }}
                            />
                        )}
                    </div>
                </a>

                <a href={"https://drive.google.com/file/d/1QBTSzyl7o37WK91fvFT4vy-QKKBYKvaD/view?usp=sharing"}
                    className={`
                        ${darkMode ? 'text-dark' : 'text-light'}
                        text-decoration-none
                    `}
                >
                    <div className='text-center mb-3'>
                        {businessCard.name === "LUIS GONZÁLEZ LOZANO" && (
                            <Button
                                id='contact-button'
                                className='w-100 contact-button'
                                color={`${darkMode ? 'primary-dark' : 'primary'}`}
                                >
                                Semblanza
                            </Button>
                        )}
                    </div>
                </a>

            </Container>
        </Container>
    )
}

export default CardPage;